import { FCC } from '@eluve/components';
import { useNamedLogger } from '@eluve/logger';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';
import {
  PeriodicLocalFileScanMachineProvider,
  PeriodicRemoteFileSyncMachineProvider,
  readAllAppointmentFilesFromOpfs,
  useDb,
  useUserFileSystemStore,
} from '@eluve/user-local-files';
import { useIsOnline } from '@eluve/utility-hooks';

/**
 * This component is a bridge between the PeriodicFileSyncProvider and the web app.
 * It provides online/offline status to the file sync machine.
 */
export const PeriodicFileSyncProviderBridge: FCC = ({ children }) => {
  const logger = useNamedLogger('PeriodicFileSyncProviderBridge');
  const db = useDb();
  const isOnline = useIsOnline();
  const tenantId = useAssignedTenantIdFromParams();
  const fileSystem = useUserFileSystemStore((state) => state.userFileSystem);

  return (
    <PeriodicRemoteFileSyncMachineProvider
      tenantId={tenantId}
      isOnline={isOnline}
    >
      {children}
      <PeriodicLocalFileScanMachineProvider
        getFileReferences={async () => {
          const dbFileRecords = await db.appointmentFiles.toArray();
          const opfsFiles = await readAllAppointmentFilesFromOpfs(
            fileSystem,
            logger,
            dbFileRecords,
          );

          return {
            dbFileRecords,
            opfsFiles,
          };
        }}
        appointmentFilesTable={db.appointmentFiles}
      />
    </PeriodicRemoteFileSyncMachineProvider>
  );
};
